// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"64":"cc912011","208":"532ab211","288":"2daa6f06","444":"bf54ecbc"}[chunkId] + ".js";
};